import React from 'react';
import PropTypes from 'prop-types';
import { FileInput } from '@els/els-react--file-input';

function UploadLink(props) {
  const { onChange } = props;
  const handleInputChange = (e) => {
    onChange(e[0]);
  };

  return (
    <>
      <FileInput label="Browse files" buttonType="secondary" className="uploadLink" sprite={null} onSelect={handleInputChange} />
      {/* this is only for automation */}
      <input
        type="file"
        id="querybuilder-importfile-input"
        style={{ display: 'none' }}
        placeholder="querybuilder-importfile-input"
        onChange={(e) => handleInputChange(e?.target?.files)}
      />
    </>
  );
}

UploadLink.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default UploadLink;
